{
  "version": 1,
  "asset_id": "6c15dec6-1389-40fc-a444-b5359b29b5a0",
  "project_id": "f3267492-75a1-4be6-8d94-522819be8b81",
  "url": "/__l5e/assets-v1/6c15dec6-1389-40fc-a444-b5359b29b5a0/david.webp",
  "r2_key": "a/v1/f3267492-75a1-4be6-8d94-522819be8b81/6c15dec6-1389-40fc-a444-b5359b29b5a0/david.webp",
  "original_filename": "david.webp",
  "size": 8738,
  "content_type": "image/webp",
  "created_at": "2026-07-17T17:22:10Z"
}
